import styled from "styled-components";
import { viewSizeCalculator } from "../../utils";

export const CheckboxContainer = styled.div`
  border-radius: ${() => `${viewSizeCalculator(1.25)}`};
  padding: 0 ${viewSizeCalculator(0.8)};
  border: ${viewSizeCalculator(0.125)} solid #3333331a;
  border: ${viewSizeCalculator(0.125)} solid
    ${({ isChecked }) => (isChecked ? "#F99C89" : "#3333331a")};
  height: ${() => `${viewSizeCalculator(3)}`};
  display: flex;
  align-items: center;
  gap: 10px;
  `